import { useContext } from 'react';
import { GenericSlotProps, SlotContext } from './SlotContext';
import { AvailableSlots } from '@upheal/design-system/utils/Slots';

export const useSlotContext = <
    P extends Record<string, any>,
    K extends AvailableSlots,
>(
    ownProps: P,
    slotName?: K,
): P & Partial<GenericSlotProps[K]> => {
    const slotsFromContext = useContext(SlotContext);

    if (!slotsFromContext || !slotName) {
        return ownProps as P & Partial<GenericSlotProps[K]>;
    }

    const slotPropsFromParent = (slotsFromContext[slotName] || {}) as Partial<
        GenericSlotProps[K]
    >;

    const mergedProps = { ...slotPropsFromParent, ...ownProps };

    return mergedProps as P & Partial<GenericSlotProps[K]>;
};
